"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addViewResourceEventOnClick = addViewResourceEventOnClick;
exports["default"] = void 0;
exports.getExternalLink = getExternalLink;
exports.getTitleStyles = getTitleStyles;
exports.isResourceImage = void 0;
exports.renderDescription = renderDescription;
exports.renderFooter = renderFooter;
exports.renderIcons = renderIcons;
exports.renderThumbnail = renderThumbnail;
exports.renderTitle = renderTitle;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _cccisdLaravelEventlog = require("cccisd-laravel-eventlog");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _helpers = require("../../../../helpers.js");
var _Course = _interopRequireDefault(require("../../Course"));
var _defaultFilterGroupIcons = _interopRequireDefault(require("../../defaultFilterGroupIcons.js"));
var _ImageFile = _interopRequireDefault(require("../../ImageFile"));
var _ShareButton = _interopRequireDefault(require("../ShareButton"));
var _index = _interopRequireDefault(require("../FavoriteButton/index.js"));
var _Product = require("../../Product");
var _Survey = require("../../Survey");
var _Video = _interopRequireDefault(require("../../Video"));
var _gridShared = _interopRequireDefault(require("./gridShared.css"));
var _style = _interopRequireDefault(require("./style.css"));
var _stopwatch = _interopRequireDefault(require("cccisd-icons/stopwatch"));
var _FlowPlayerWrapper = _interopRequireDefault(require("../../../FlowPlayerWrapper.js"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var appDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var isResourceImage = exports.isResourceImage = function isResourceImage(resource) {
  return resource.type === 'document' && ['.png', '.jpg'].includes(resource.filename.slice(resource.filename.lastIndexOf('.')).toLowerCase());
};
function getExternalLink(resource) {
  var metadata = JSON.parse(resource.published_metadata) || {};
  if (resource.type === 'document') {
    var url = resource.url;
    if (resource.published_label) {
      url += "?filename=".concat(resource.published_label); // do not add file extension here
    }
    return url;
  }
  if (resource.type === 'link' || resource.type === 'product' && metadata.link) {
    return metadata.link;
  }
  if (resource.type === 'course') {
    if (metadata.courseCustomUrl) {
      if ((0, _helpers.isValidInternalLink)(metadata.courseCustomUrl)) {
        return Boilerplate.url(metadata.courseCustomUrl);
      }
      return metadata.courseCustomUrl;
    }
    if (!(0, _get2["default"])(resource.courseData, 'isOpen')) {
      return null;
    }
    var respondentHash = (0, _get2["default"])(resource.courseData, 'settings.requireLogin') || Fortress.user.acting.role.handle === 'guest' || resource.courseData.type === 'anon' ? '' : "/".concat(Fortress.user.acting.respondent_hash);
    return Boilerplate.url("/d/".concat(resource.courseData.hash).concat(respondentHash));
  }
}
function addViewResourceEventOnClick(resource) {
  var viewResourceEvent = function viewResourceEvent() {
    (0, _cccisdLaravelEventlog.addEvent)({
      eventType: 'viewResource',
      targetId: resource.id,
      targetType: 'resource'
    });
  };
  return {
    onClick: viewResourceEvent,
    onContextMenu: viewResourceEvent
  };
}
function renderTitle(resource, displayOptions) {
  var metadata = JSON.parse(resource.published_metadata);
  if (resource.type === 'video' || isResourceImage(resource)) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
        href: ""
      }, addViewResourceEventOnClick(resource)), /*#__PURE__*/_react["default"].createElement("h2", {
        className: _gridShared["default"].title,
        style: getTitleStyles(displayOptions)
      }, resource.published_label)),
      size: "large",
      title: resource.published_label
    }, resource.type === 'video' && /*#__PURE__*/_react["default"].createElement(_Video["default"], {
      resource: resource
    }), isResourceImage(resource) && /*#__PURE__*/_react["default"].createElement(_ImageFile["default"], {
      resource: resource
    }));
  }
  if (resource.type === 'course' || resource.type === 'product') {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: _gridShared["default"].title,
      style: getTitleStyles(displayOptions)
    }, resource.published_label);
  }
  if (resource.type === 'survey') {
    var resourceTitle = resource.published_label;
    if (metadata.useSurveyTitle === true) {
      var _metadata$surveyInfo;
      resourceTitle = (_metadata$surveyInfo = metadata.surveyInfo) !== null && _metadata$surveyInfo !== void 0 && _metadata$surveyInfo.surveyLabel ? metadata.surveyInfo.surveyLabel : resource.published_label;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
        href: ""
      }, addViewResourceEventOnClick(resource)), /*#__PURE__*/_react["default"].createElement("h2", {
        className: _gridShared["default"].title,
        style: getTitleStyles(displayOptions)
      }, resourceTitle)),
      title: "".concat(resourceTitle, " Preview"),
      size: "large",
      contentStyle: {
        width: '1200px'
      },
      headerStyle: {
        backgroundColor: '#2F8B86',
        color: '#fff'
      },
      bodyStyle: {
        backgroundColor: '#edf2f7'
      },
      render: function render(_ref) {
        var closeModal = _ref.closeModal;
        return /*#__PURE__*/_react["default"].createElement("div", null, displayOptions.showSurveyPreviewMessage && /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: '2em'
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null), ' ', metadata.previewText || 'This is a preview only. No responses will be collected or saved.')), /*#__PURE__*/_react["default"].createElement(_FlowPlayerWrapper["default"], {
          flowId: [metadata.surveyInfo.flowList[0].flowId],
          isPreviewMode: true,
          onComplete: closeModal
        }));
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    href: getExternalLink(resource),
    target: "_blank",
    rel: "noopener noreferrer"
  }, addViewResourceEventOnClick(resource)), /*#__PURE__*/_react["default"].createElement("h2", {
    className: _gridShared["default"].title,
    style: getTitleStyles(displayOptions)
  }, resource.published_label));
}
function renderDescription(resource, displayOptions) {
  var _JSON$parse;
  if (resource.type === 'course') {
    return /*#__PURE__*/_react["default"].createElement(_Course["default"], {
      resource: resource
    });
  }
  if (resource.type === 'product') {
    return /*#__PURE__*/_react["default"].createElement(_Product.ProductDetails, {
      resource: resource,
      displayOptions: displayOptions
    });
  }
  if (resource.type === 'survey') {
    return /*#__PURE__*/_react["default"].createElement(_Survey.Details, {
      resource: resource,
      displayOptions: displayOptions
    });
  }
  var description = displayOptions.showDescription && /*#__PURE__*/_react["default"].createElement("p", {
    className: _gridShared["default"].desc,
    dangerouslySetInnerHTML: {
      __html: resource.published_description
    },
    style: displayOptions.descriptionTextColor ? {
      color: displayOptions.descriptionTextColor
    } : {}
  });
  var videoTime = (_JSON$parse = JSON.parse(resource.published_metadata)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.runtime;
  if (resource.type === 'video' && videoTime > '0:00:01') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].stopWatch
    }, /*#__PURE__*/_react["default"].createElement(_stopwatch["default"], null), " ", videoTime), description);
  }
  return description;
}
function renderThumbnail(resource) {
  if (resource.type === 'video' || isResourceImage(resource)) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("a", _extends({
        href: ""
      }, addViewResourceEventOnClick(resource)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbImage,
        style: {
          backgroundImage: "url(".concat(resource.small, ")")
        }
      })),
      size: "large",
      title: resource.published_label
    }, resource.type === 'video' ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
      resource: resource
    }) : /*#__PURE__*/_react["default"].createElement(_ImageFile["default"], {
      resource: resource
    }));
  }
  var thumbNail = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].thumbImage,
    style: {
      backgroundImage: "url(".concat(resource.small, ")")
    }
  });
  if (['product'].includes(resource.type)) {
    return thumbNail;
  }
  var courseClosed = resource.type === 'course' && !resource.courseData.isOpen;
  var linkProps = resource.type !== 'course' ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : null;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    href: getExternalLink(resource),
    style: courseClosed && {
      cursor: 'not-allowed'
    } || {}
  }, linkProps, addViewResourceEventOnClick(resource)), thumbNail);
}
function getTitleStyles(displayOptions) {
  var textTransform;
  var color;
  if (displayOptions.uppercaseTitle) {
    textTransform = 'uppercase';
  }
  if (displayOptions.titleColor) {
    color = displayOptions.titleColor;
  }
  return {
    color: color,
    textTransform: textTransform
  };
}
function renderIcons(resource, displayOptions) {
  var getIcon = function getIcon(icon) {
    var filterGroupIcon;
    if (icon) {
      if (appDefs.resourceCenters.filterGroupIcons) {
        filterGroupIcon = appDefs.resourceCenters.filterGroupIcons.find(function (fg) {
          return fg.id === icon;
        });
      } else {
        filterGroupIcon = _defaultFilterGroupIcons["default"].find(function (fg) {
          return fg.id === icon;
        });
      }
    }
    return filterGroupIcon;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayOptions.showFilterGroupIcons && resource.icons.length > 0 && resource.icons.map(function (icn, icnIndex) {
    var icon = getIcon(icn.name);
    return /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        margin: '0 0.5em',
        color: icn.color
      },
      key: icn.name + icnIndex
    }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
      viewBox: icon.viewBox,
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: p
      });
    }))));
  }));
}
function renderFooter(resource, displayOptions, getShareUrl, currentTab, collection, addToCollection, removeFromCollection, addToCollectionButtonLabel, useFavorite) {
  if (resource.type === 'product') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _gridShared["default"].footer
    }, /*#__PURE__*/_react["default"].createElement(_Product.ProductFooter, {
      resource: resource,
      useFavorite: useFavorite,
      displayOptions: displayOptions,
      externalShareUrl: getShareUrl(currentTab, resource)
    }));
  }
  if (resource.type === 'survey') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _gridShared["default"].footer
    }, /*#__PURE__*/_react["default"].createElement(_Survey.Footer, {
      resource: resource,
      useFavorite: useFavorite,
      displayOptions: displayOptions,
      externalShareUrl: getShareUrl(currentTab, resource),
      collection: collection,
      addToCollection: addToCollection,
      removeFromCollection: removeFromCollection,
      addToCollectionButtonLabel: addToCollectionButtonLabel
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'row ' + _gridShared["default"].footer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, displayOptions.showTags && /*#__PURE__*/_react["default"].createElement("p", {
    className: _gridShared["default"].tags
  }, resource.tags && Object.keys(resource.tags).map(function (tag, j) {
    if (Object.keys(resource.tags).length === j + 1) {
      return resource.tags[tag];
    }
    return resource.tags[tag] + ', ';
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3",
    style: {
      display: 'flex'
    }
  }, renderIcons(resource, displayOptions)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'col-3 ' + _gridShared["default"].shareBtn
  }, displayOptions.showFavoriteIcon && /*#__PURE__*/_react["default"].createElement(_index["default"], {
    resource: resource,
    useFavorite: useFavorite,
    color: displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.favoriteButtonColor
  }), displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
    name: resource.published_label,
    url: getShareUrl(currentTab, resource),
    displayOptions: displayOptions
  })));
}
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    _classCallCheck(this, Component);
    return _callSuper(this, Component, arguments);
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        getShareUrl = _this$props.getShareUrl,
        currentTab = _this$props.currentTab,
        collection = _this$props.collection,
        addToCollection = _this$props.addToCollection,
        removeFromCollection = _this$props.removeFromCollection,
        addToCollectionButtonLabel = _this$props.addToCollectionButtonLabel,
        useFavorite = _this$props.useFavorite;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _gridShared["default"].wrapper
      }, this.props.data.map(function (resource, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: resource.type === 'product' ? _gridShared["default"].productItem : "".concat(_gridShared["default"].item, " ").concat(_style["default"].item),
          style: {
            borderLeft: resource.borderColor && "10px solid ".concat((0, _helpers.getBorderColor)(resource.borderColor))
          },
          key: resource.id
        }, displayOptions.showThumbnail && renderThumbnail(resource), /*#__PURE__*/_react["default"].createElement("div", {
          className: _gridShared["default"].content
        }, /*#__PURE__*/_react["default"].createElement("div", null, renderTitle(resource, displayOptions), renderDescription(resource, displayOptions))), renderFooter(resource, displayOptions, getShareUrl, currentTab, collection, addToCollection, removeFromCollection, addToCollectionButtonLabel, useFavorite));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  currentTab: _propTypes["default"].string,
  data: _propTypes["default"].array.isRequired,
  getShareUrl: _propTypes["default"].func,
  displayOptions: _propTypes["default"].object,
  collection: _propTypes["default"].array,
  addToCollection: _propTypes["default"].func,
  removeFromCollection: _propTypes["default"].func,
  addToCollectionButtonLabel: _propTypes["default"].string,
  useFavorite: _propTypes["default"].func
});